// Calculate rent price based on rent period

document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('.rent-period-radio');
  const basePriceElementList = document.querySelectorAll('.property-base-price');
  const fullPriceElementList = document.querySelectorAll('.property-full-price');
  const discountedPrice = document.querySelectorAll('p:has(.property-full-price) sup');

  function formatNumber(value, decimals = 0) {
    return Number(value).toLocaleString('pl-PL', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      useGrouping: true,
    }).replace(',', '.');
  }

  function updatePrice() {
    const selected = document.querySelector('.rent-period-radio:checked');
    if (!selected) return;

    const basePrice = Number(
      String(selected.dataset.basePrice).replace(/[ ,]/g, '')
    );
    const charges = Number(
      String(selected.dataset.charges).replace(/[ ,]/g, '')
    );
    const multiplier = Number(selected.dataset.multiplier);
    const newPrice = basePrice * multiplier;
    const newFullPrice = newPrice + charges;

    const is12MonthsSelected = selected.value == 12;
    discountedPrice.forEach(discount => discount.classList.toggle('d-none', !is12MonthsSelected));

    fullPriceElementList.forEach(priceItem => priceItem.textContent = formatNumber(newFullPrice));
    basePriceElementList.forEach(priceItem => priceItem.textContent = formatNumber(newPrice, 2));

    radios.forEach(radio => {
      radio.checked = (radio.value === selected.value);
    });
  }

  radios.forEach(radio => {
    radio.addEventListener('change', updatePrice);
  });

  updatePrice();
});